import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { contabilidadeDigitalLandingPage } from '@ibk/shared-assets';
import { useTranslation } from '@ibk/shared-translation';
import { AppDomain } from '@ibk/shared-types';
import { LandingPageBase } from './LandigPageBase/LandingPageBase';
const featuresList = [
    {
        icon: 'check',
        translationKey: 'contabilidade-digital.landing.escritorio.feature-1',
    },
    {
        icon: 'arrowsRotate',
        translationKey: 'contabilidade-digital.landing.escritorio.feature-2',
    },
    {
        icon: 'listCheck',
        translationKey: 'contabilidade-digital.landing.escritorio.feature-3',
    },
    {
        icon: 'sitemap',
        translationKey: 'contabilidade-digital.landing.escritorio.feature-4',
    },
];
export const LandingPageEscritorio = () => {
    const { t } = useTranslation();
    return (_jsx(LandingPageBase, { image: contabilidadeDigitalLandingPage, title: t('contabilidade-digital.landing.escritorio.title'), subtitle: t('contabilidade-digital.landing.escritorio.subtitle'), mainTitle: t('contabilidade-digital.landing.escritorio.main-title'), featuresList: featuresList, buttonText: t('contabilidade-digital.landing.escritorio.cta-button'), buttonClickHandler: () => {
            window.open('https://suporte.dominioatendimento.com/contratacao/faces/dominio-contabilidade-digital.html?idContratacao=2', '_blank');
        }, domain: AppDomain.ESCRITORIO }));
};
